webpackJsonp([114276838955818,60335399758886],{

/***/ 90:
/***/ (function(module, exports) {

	module.exports = {"data":{"allTranslationsXlsxSections":{"edges":[{"node":{"url":"general","title":"General","title_nl":"Algemeen","title_de":"Allgemein"}},{"node":{"url":"header","title":"Header","title_nl":"Header","title_de":"Header"}},{"node":{"url":"navigation","title":"Navigation","title_nl":"Navigatie","title_de":"Menü"}},{"node":{"url":"footer","title":"Footer","title_nl":"Footer","title_de":"Footer"}},{"node":{"url":"usp","title":"USP","title_nl":"USP","title_de":"USP"}},{"node":{"url":"product","title":"Product","title_nl":"Product","title_de":"Produkt"}},{"node":{"url":"quickview","title":"Quickview","title_nl":"Quickview","title_de":"Quickview"}},{"node":{"url":"pagination","title":"Pagination","title_nl":"Paginering","title_de":"Paginierung"}},{"node":{"url":"tags","title":"Tags","title_nl":"Tags","title_de":"Tags"}},{"node":{"url":"homepage","title":"Homepage","title_nl":"Homepagina","title_de":"Homepage"}},{"node":{"url":"catalog-page","title":"Catalog page","title_nl":"Catalogus pagina","title_de":"Katalogseite"}},{"node":{"url":"collection-page","title":"Collection page","title_nl":"Collectie pagina","title_de":"Kollektion Seite"}},{"node":{"url":"product-page","title":"Product page","title_nl":"Product pagina","title_de":"Produktseite"}}]},"allTranslationsXlsxHomepage":{"edges":[{"node":{"heading":"Introduction","heading_nl":"Introductie","heading_de":"Einführung"}}]},"allTranslationsXlsxChangelog":{"edges":[{"node":{"version":"v1.6.0"}},{"node":{"version":"v1.5.0"}},{"node":{"version":"v1.4.0"}},{"node":{"version":"v1.3.0"}},{"node":{"version":"v1.2.0"}},{"node":{"version":"v1.1.0"}},{"node":{"version":"v1.0.0"}}]}},"layoutContext":{}}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(180);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(90);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	/* -----------------------------------------------
	/* Author : Vincent Garreau  - vincentgarreau.com
	/* MIT license: http://opensource.org/licenses/MIT
	/* Demo / Generator : vincentgarreau.com/particles.js
	/* GitHub : github.com/VincentGarreau/particles.js
	/* How to use? : Check the GitHub README
	/* v2.0.0
	/* ----------------------------------------------- */
	
	var pJS = function(tag_id, params){
	
	  var canvas_el = document.querySelector('#'+tag_id+' > .particles-js-canvas-el');
	
	  /* particles.js variables with default values */
	  this.pJS = {
	    canvas: {
	      el: canvas_el,
	      w: canvas_el.offsetWidth,
	      h: canvas_el.offsetHeight
	    },
	    particles: {
	      number: {
	        value: 400,
	        density: {
	          enable: true,
	          value_area: 800
	        }
	      },
	      color: {
	        value: '#fff'
	      },
	      shape: {
	        type: 'circle',
	        stroke: {
	          width: 0,
	          color: '#ff0000'
	        },
	        polygon: {
	          nb_sides: 5
	        },
	        image: {
	          src: '',
	          width: 100,
	          height: 100
	        }
	      },
	      opacity: {
	        value: 1,
	        random: false,
	        anim: {
	          enable: false,
	          speed: 2,
	          opacity_min: 0,
	          sync: false
	        }
	      },
	      size: {
	        value: 20,
	        random: false,
	        anim: {
	          enable: false,
	          speed: 20,
	          size_min: 0,
	          sync: false
	        }
	      },
	      line_linked: {
	        enable: true,
	        distance: 100,
	        color: '#fff',
	        opacity: 1,
	        width: 1
	      },
	      move: {
	        enable: true,
	        speed: 2,
	        direction: 'none',
	        random: false,
	        straight: false,
	        out_mode: 'out',
	        bounce: false,
	        attract: {
	          enable: false,
	          rotateX: 3000,
	          rotateY: 3000
	        }
	      },
	      array: []
	    },
	    interactivity: {
	      detect_on: 'canvas',
	      events: {
	        onhover: {
	          enable: true,
	          mode: 'grab'
	        },
	        onclick: {
	          enable: true,
	          mode: 'push'
	        },
	        resize: true
	      },
	      modes: {
	        grab:{
	          distance: 100,
	          line_linked:{
	            opacity: 1
	          }
	        },
	        bubble:{
	          distance: 200,
	          size: 80,
	          duration: 0.4
	        },
	        repulse:{
	          distance: 200,
	          duration: 0.4
	        },
	        push:{
	          particles_nb: 4
	        },
	        remove:{
	          particles_nb: 2
	        }
	      },
	      mouse:{}
	    },
	    retina_detect: false,
	    fn: {
	      interact: {},
	      modes: {},
	      vendors:{}
	    },
	    tmp: {}
	  };
	
	  var pJS = this.pJS;
	
	  /* params settings */
	  if(params){
	    Object.deepExtend(pJS, params);
	  }
	
	  pJS.tmp.obj = {
	    size_value: pJS.particles.size.value,
	    size_anim_speed: pJS.particles.size.anim.speed,
	    move_speed: pJS.particles.move.speed,
	    line_linked_distance: pJS.particles.line_linked.distance,
	    line_linked_width: pJS.particles.line_linked.width,
	    mode_grab_distance: pJS.interactivity.modes.grab.distance,
	    mode_bubble_distance: pJS.interactivity.modes.bubble.distance,
	    mode_bubble_size: pJS.interactivity.modes.bubble.size,
	    mode_repulse_distance: pJS.interactivity.modes.repulse.distance
	  };
	
	
	  pJS.fn.retinaInit = function(){
	
	    if(pJS.retina_detect && window.devicePixelRatio > 1){
	      pJS.canvas.pxratio = window.devicePixelRatio; 
	      pJS.tmp.retina = true;
	    } 
	    else{
	      pJS.canvas.pxratio = 1;
	      pJS.tmp.retina = false;
	    }
	
	    pJS.canvas.w = pJS.canvas.el.offsetWidth * pJS.canvas.pxratio;
	    pJS.canvas.h = pJS.canvas.el.offsetHeight * pJS.canvas.pxratio;
	
	    pJS.particles.size.value = pJS.tmp.obj.size_value * pJS.canvas.pxratio;
	    pJS.particles.size.anim.speed = pJS.tmp.obj.size_anim_speed * pJS.canvas.pxratio;
	    pJS.particles.move.speed = pJS.tmp.obj.move_speed * pJS.canvas.pxratio;
	    pJS.particles.line_linked.distance = pJS.tmp.obj.line_linked_distance * pJS.canvas.pxratio;
	    pJS.interactivity.modes.grab.distance = pJS.tmp.obj.mode_grab_distance * pJS.canvas.pxratio;
	    pJS.interactivity.modes.bubble.distance = pJS.tmp.obj.mode_bubble_distance * pJS.canvas.pxratio;
	    pJS.particles.line_linked.width = pJS.tmp.obj.line_linked_width * pJS.canvas.pxratio;
	    pJS.interactivity.modes.bubble.size = pJS.tmp.obj.mode_bubble_size * pJS.canvas.pxratio;
	    pJS.interactivity.modes.repulse.distance = pJS.tmp.obj.mode_repulse_distance * pJS.canvas.pxratio;
	
	  };
	
	
	
	  /* ---------- pJS functions - canvas ------------ */
	
	  pJS.fn.canvasInit = function(){
	    pJS.canvas.ctx = pJS.canvas.el.getContext('2d');
	  };
	
	  pJS.fn.canvasSize = function(){
	
	    pJS.canvas.el.width = pJS.canvas.w;
	    pJS.canvas.el.height = pJS.canvas.h;
	
	    if(pJS && pJS.interactivity.events.resize){
	
	      window.addEventListener('resize', function(){
	
	          pJS.canvas.w = pJS.canvas.el.offsetWidth;
	          pJS.canvas.h = pJS.canvas.el.offsetHeight;
	
	          /* resize canvas */
	          if(pJS.tmp.retina){
	            pJS.canvas.w *= pJS.canvas.pxratio;
	            pJS.canvas.h *= pJS.canvas.pxratio;
	          }
	
	          pJS.canvas.el.width = pJS.canvas.w;
	          pJS.canvas.el.height = pJS.canvas.h;
	
	          /* repaint canvas on anim disabled */
	          if(!pJS.particles.move.enable){
	            pJS.fn.particlesEmpty();
	            pJS.fn.particlesCreate();
	            pJS.fn.particlesDraw();
	            pJS.fn.vendors.densityAutoParticles();
	          }
	
	        /* density particles enabled */
	        pJS.fn.vendors.densityAutoParticles();
	
	      });
	
	    }
	
	  };
	
	
	  pJS.fn.canvasPaint = function(){
	    pJS.canvas.ctx.fillRect(0, 0, pJS.canvas.w, pJS.canvas.h);
	  };
	
	  pJS.fn.canvasClear = function(){
	    pJS.canvas.ctx.clearRect(0, 0, pJS.canvas.w, pJS.canvas.h);
	  };
	
	
	  /* --------- pJS functions - particles ----------- */
	
	  pJS.fn.particle = function(color, opacity, position){
	
	    /* size */
	    this.radius = (pJS.particles.size.random ? Math.random() : 1) * pJS.particles.size.value;
	    if(pJS.particles.size.anim.enable){
	      this.size_status = false;
	      this.vs = pJS.particles.size.anim.speed / 100;
	      if(!pJS.particles.size.anim.sync){
	        this.vs = this.vs * Math.random();
	      }
	    }
	
	    /* position */
	    this.x = position ? position.x : Math.random() * pJS.canvas.w;
	    this.y = position ? position.y : Math.random() * pJS.canvas.h;
	
	    /* check position  - into the canvas */
	    if(this.x > pJS.canvas.w - this.radius*2) this.x = this.x - this.radius;
	    else if(this.x < this.radius*2) this.x = this.x + this.radius;
	    if(this.y > pJS.canvas.h - this.radius*2) this.y = this.y - this.radius;
	    else if(this.y < this.radius*2) this.y = this.y + this.radius;
	
	    /* check position - avoid overlap */
	    if(pJS.particles.move.bounce){
	      pJS.fn.vendors.checkOverlap(this, position);
	    }
	
	    /* color */
	    this.color = {};
	    if(typeof(color.value) == 'object'){
	
	      if(color.value instanceof Array){
	        var color_selected = color.value[Math.floor(Math.random() * pJS.particles.color.value.length)];
	        this.color.rgb = hexToRgb(color_selected);
	      }else{
	        if(color.value.r != undefined && color.value.g != undefined && color.value.b != undefined){
	          this.color.rgb = {
	            r: color.value.r,
	            g: color.value.g,
	            b: color.value.b
	          }
	        }
	        if(color.value.h != undefined && color.value.s != undefined && color.value.l != undefined){
	          this.color.hsl = {
	            h: color.value.h,
	            s: color.value.s,
	            l: color.value.l
	          }
	        }
	      }
	
	    }
	    else if(color.value == 'random'){
	      this.color.rgb = {
	        r: (Math.floor(Math.random() * (255 - 0 + 1)) + 0),
	        g: (Math.floor(Math.random() * (255 - 0 + 1)) + 0),
	        b: (Math.floor(Math.random() * (255 - 0 + 1)) + 0)
	      }
	    }
	    else if(typeof(color.value) == 'string'){
	      this.color = color;
	      this.color.rgb = hexToRgb(this.color.value);
	    }
	
	    /* opacity */
	    this.opacity = (pJS.particles.opacity.random ? Math.random() : 1) * pJS.particles.opacity.value;
	    if(pJS.particles.opacity.anim.enable){
	      this.opacity_status = false;
	      this.vo = pJS.particles.opacity.anim.speed / 100;
	      if(!pJS.particles.opacity.anim.sync){
	        this.vo = this.vo * Math.random();
	      }
	    }
	
	    /* animation - velocity for speed */
	    var velbase = {}
	    switch(pJS.particles.move.direction){
	      case 'top':
	        velbase = { x:0, y:-1 };
	      break;
	      case 'top-right':
	        velbase = { x:0.5, y:-0.5 };
	      break;
	      case 'right':
	        velbase = { x:1, y:-0 };
	      break;
	      case 'bottom-right':
	        velbase = { x:0.5, y:0.5 };
	      break;
	      case 'bottom':
	        velbase = { x:0, y:1 };
	      break;
	      case 'bottom-left':
	        velbase = { x:-0.5, y:1 };
	      break;
	      case 'left':
	        velbase = { x:-1, y:0 };
	      break;
	      case 'top-left':
	        velbase = { x:-0.5, y:-0.5 };
	      break;
	      default:
	        velbase = { x:0, y:0 };
	      break;
	    }
	
	    if(pJS.particles.move.straight){
	      this.vx = velbase.x;
	      this.vy = velbase.y;
	      if(pJS.particles.move.random){
	        this.vx = this.vx * (Math.random());
	        this.vy = this.vy * (Math.random());
	      }
	    }else{
	      this.vx = velbase.x + Math.random()-0.5;
	      this.vy = velbase.y + Math.random()-0.5;
	    }
	
	    // var theta = 2.0 * Math.PI * Math.random();
	    // this.vx = Math.cos(theta);
	    // this.vy = Math.sin(theta);
	
	    this.vx_i = this.vx;
	    this.vy_i = this.vy;
	
	    
	
	    /* if shape is image */
	
	    var shape_type = pJS.particles.shape.type;
	    if(typeof(shape_type) == 'object'){
	      if(shape_type instanceof Array){
	        var shape_selected = shape_type[Math.floor(Math.random() * shape_type.length)];
	        this.shape = shape_selected;
	      }
	    }else{
	      this.shape = shape_type;
	    }
	
	    if(this.shape == 'image'){
	      var sh = pJS.particles.shape;
	      this.img = {
	        src: sh.image.src,
	        ratio: sh.image.width / sh.image.height
	      }
	      if(!this.img.ratio) this.img.ratio = 1;
	      if(pJS.tmp.img_type == 'svg' && pJS.tmp.source_svg != undefined){
	        pJS.fn.vendors.createSvgImg(this);
	        if(pJS.tmp.pushing){
	          this.img.loaded = false;
	        }
	      }
	    }
	
	    
	
	  };
	
	
	  pJS.fn.particle.prototype.draw = function() {
	
	    var p = this;
	
	    if(p.radius_bubble != undefined){
	      var radius = p.radius_bubble; 
	    }else{
	      var radius = p.radius;
	    }
	
	    if(p.opacity_bubble != undefined){
	      var opacity = p.opacity_bubble;
	    }else{
	      var opacity = p.opacity;
	    }
	
	    if(p.color.rgb){
	      var color_value = 'rgba('+p.color.rgb.r+','+p.color.rgb.g+','+p.color.rgb.b+','+opacity+')';
	    }else{
	      var color_value = 'hsla('+p.color.hsl.h+','+p.color.hsl.s+'%,'+p.color.hsl.l+'%,'+opacity+')';
	    }
	
	    pJS.canvas.ctx.fillStyle = color_value;
	    pJS.canvas.ctx.beginPath();
	
	    switch(p.shape){
	
	      case 'circle':
	        pJS.canvas.ctx.arc(p.x, p.y, radius, 0, Math.PI * 2, false);
	      break;
	
	      case 'edge':
	        pJS.canvas.ctx.rect(p.x-radius, p.y-radius, radius*2, radius*2);
	      break;
	
	      case 'triangle':
	        pJS.fn.vendors.drawShape(pJS.canvas.ctx, p.x-radius, p.y+radius / 1.66, radius*2, 3, 2);
	      break;
	
	      case 'polygon':
	        pJS.fn.vendors.drawShape(
	          pJS.canvas.ctx,
	          p.x - radius / (pJS.particles.shape.polygon.nb_sides/3.5), // startX
	          p.y - radius / (2.66/3.5), // startY
	          radius*2.66 / (pJS.particles.shape.polygon.nb_sides/3), // sideLength
	          pJS.particles.shape.polygon.nb_sides, // sideCountNumerator
	          1 // sideCountDenominator
	        );
	      break;
	
	      case 'star':
	        pJS.fn.vendors.drawShape(
	          pJS.canvas.ctx,
	          p.x - radius*2 / (pJS.particles.shape.polygon.nb_sides/4), // startX
	          p.y - radius / (2*2.66/3.5), // startY
	          radius*2*2.66 / (pJS.particles.shape.polygon.nb_sides/3), // sideLength
	          pJS.particles.shape.polygon.nb_sides, // sideCountNumerator
	          2 // sideCountDenominator
	        );
	      break;
	
	      case 'image':
	
	        function draw(){
	          pJS.canvas.ctx.drawImage(
	            img_obj,
	            p.x-radius,
	            p.y-radius,
	            radius*2,
	            radius*2 / p.img.ratio
	          );
	        }
	
	        if(pJS.tmp.img_type == 'svg'){
	          var img_obj = p.img.obj;
	        }else{
	          var img_obj = pJS.tmp.img_obj;
	        }
	
	        if(img_obj){
	          draw();
	        }
	
	      break;
	
	    }
	
	    pJS.canvas.ctx.closePath();
	
	    if(pJS.particles.shape.stroke.width > 0){
	      pJS.canvas.ctx.strokeStyle = pJS.particles.shape.stroke.color;
	      pJS.canvas.ctx.lineWidth = pJS.particles.shape.stroke.width;
	      pJS.canvas.ctx.stroke();
	    }
	    
	    pJS.canvas.ctx.fill();
	    
	  };
	
	
	  pJS.fn.particlesCreate = function(){
	    for(var i = 0; i < pJS.particles.number.value; i++) {
	      pJS.particles.array.push(new pJS.fn.particle(pJS.particles.color, pJS.particles.opacity.value));
	    }
	  };
	
	  pJS.fn.particlesUpdate = function(){
	
	    for(var i = 0; i < pJS.particles.array.length; i++){
	
	      /* the particle */
	      var p = pJS.particles.array[i];
	
	      // var d = ( dx = pJS.interactivity.mouse.click_pos_x - p.x ) * dx + ( dy = pJS.interactivity.mouse.click_pos_y - p.y ) * dy;
	      // var f = -BANG_SIZE / d;
	      // if ( d < BANG_SIZE ) {
	      //     var t = Math.atan2( dy, dx );
	      //     p.vx = f * Math.cos(t);
	      //     p.vy = f * Math.sin(t);
	      // }
	
	      /* move the particle */
	      if(pJS.particles.move.enable){
	        var ms = pJS.particles.move.speed/2;
	        p.x += p.vx * ms;
	        p.y += p.vy * ms;
	      }
	
	      /* change opacity status */
	      if(pJS.particles.opacity.anim.enable) {
	        if(p.opacity_status == true) {
	          if(p.opacity >= pJS.particles.opacity.value) p.opacity_status = false;
	          p.opacity += p.vo;
	        }else {
	          if(p.opacity <= pJS.particles.opacity.anim.opacity_min) p.opacity_status = true;
	          p.opacity -= p.vo;
	        }
	        if(p.opacity < 0) p.opacity = 0;
	      }
	
	      /* change size */
	      if(pJS.particles.size.anim.enable){
	        if(p.size_status == true){
	          if(p.radius >= pJS.particles.size.value) p.size_status = false;
	          p.radius += p.vs;
	        }else{
	          if(p.radius <= pJS.particles.size.anim.size_min) p.size_status = true;
	          p.radius -= p.vs;
	        }
	        if(p.radius < 0) p.radius = 0;
	      }
	
	      /* change particle position if it is out of canvas */
	      if(pJS.particles.move.out_mode == 'bounce'){
	        var new_pos = {
	          x_left: p.radius,
	          x_right:  pJS.canvas.w,
	          y_top: p.radius,
	          y_bottom: pJS.canvas.h
	        }
	      }else{
	        var new_pos = {
	          x_left: -p.radius,
	          x_right: pJS.canvas.w + p.radius,
	          y_top: -p.radius,
	          y_bottom: pJS.canvas.h + p.radius
	        }
	      }
	
	      if(p.x - p.radius > pJS.canvas.w){
	        p.x = new_pos.x_left;
	        p.y = Math.random() * pJS.canvas.h;
	      }
	      else if(p.x + p.radius < 0){
	        p.x = new_pos.x_right;
	        p.y = Math.random() * pJS.canvas.h;
	      }
	      if(p.y - p.radius > pJS.canvas.h){
	        p.y = new_pos.y_top;
	        p.x = Math.random() * pJS.canvas.w;
	      }
	      else if(p.y + p.radius < 0){
	        p.y = new_pos.y_bottom;
	        p.x = Math.random() * pJS.canvas.w;
	      }
	
	      /* out of canvas modes */
	      switch(pJS.particles.move.out_mode){
	        case 'bounce':
	          if (p.x + p.radius > pJS.canvas.w) p.vx = -p.vx;
	          else if (p.x - p.radius < 0) p.vx = -p.vx;
	          if (p.y + p.radius > pJS.canvas.h) p.vy = -p.vy;
	          else if (p.y - p.radius < 0) p.vy = -p.vy;
	        break;
	      }
	
	      /* events */
	      if(isInArray('grab', pJS.interactivity.events.onhover.mode)){
	        pJS.fn.modes.grabParticle(p);
	      }
	
	      if(isInArray('bubble', pJS.interactivity.events.onhover.mode) || isInArray('bubble', pJS.interactivity.events.onclick.mode)){
	        pJS.fn.modes.bubbleParticle(p);
	      }
	
	      if(isInArray('repulse', pJS.interactivity.events.onhover.mode) || isInArray('repulse', pJS.interactivity.events.onclick.mode)){
	        pJS.fn.modes.repulseParticle(p);
	      }
	
	      /* interaction auto between particles */
	      if(pJS.particles.line_linked.enable || pJS.particles.move.attract.enable){
	        for(var j = i + 1; j < pJS.particles.array.length; j++){
	          var p2 = pJS.particles.array[j];
	
	          /* link particles */
	          if(pJS.particles.line_linked.enable){
	            pJS.fn.interact.linkParticles(p,p2);
	          }
	
	          /* attract particles */
	          if(pJS.particles.move.attract.enable){
	            pJS.fn.interact.attractParticles(p,p2);
	          }
	
	          /* bounce particles */
	          if(pJS.particles.move.bounce){
	            pJS.fn.interact.bounceParticles(p,p2);
	          }
	
	        }
	      }
	
	
	    }
	
	  };
	
	  pJS.fn.particlesDraw = function(){
	
	    /* clear canvas */
	    pJS.canvas.ctx.clearRect(0, 0, pJS.canvas.w, pJS.canvas.h);
	
	    /* update each particles param */
	    pJS.fn.particlesUpdate();
	
	    /* draw each particle */
	    for(var i = 0; i < pJS.particles.array.length; i++){
	      var p = pJS.particles.array[i];
	      p.draw();
	    }
	
	  };
	
	  pJS.fn.particlesEmpty = function(){
	    pJS.particles.array = [];
	  };
	
	  pJS.fn.particlesRefresh = function(){
	
	    /* init all */
	    cancelRequestAnimFrame(pJS.fn.checkAnimFrame);
	    cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
	    pJS.tmp.source_svg = undefined;
	    pJS.tmp.img_obj = undefined;
	    pJS.tmp.count_svg = 0;
	    pJS.fn.particlesEmpty();
	    pJS.fn.canvasClear();
	    
	    /* restart */
	    pJS.fn.vendors.start();
	
	  };
	
	
	  /* ---------- pJS functions - particles interaction ------------ */
	
	  pJS.fn.interact.linkParticles = function(p1, p2){
	
	    var dx = p1.x - p2.x,
	        dy = p1.y - p2.y,
	        dist = Math.sqrt(dx*dx + dy*dy);
	
	    /* draw a line between p1 and p2 if the distance between them is under the config distance */
	    if(dist <= pJS.particles.line_linked.distance){
	
	      var opacity_line = pJS.particles.line_linked.opacity - (dist / (1/pJS.particles.line_linked.opacity)) / pJS.particles.line_linked.distance;
	
	      if(opacity_line > 0){        
	        
	        /* style */
	        var color_line = pJS.particles.line_linked.color_rgb_line;
	        pJS.canvas.ctx.strokeStyle = 'rgba('+color_line.r+','+color_line.g+','+color_line.b+','+opacity_line+')';
	        pJS.canvas.ctx.lineWidth = pJS.particles.line_linked.width;
	        //pJS.canvas.ctx.lineCap = 'round'; /* performance issue */
	        
	        /* path */
	        pJS.canvas.ctx.beginPath();
	        pJS.canvas.ctx.moveTo(p1.x, p1.y);
	        pJS.canvas.ctx.lineTo(p2.x, p2.y);
	        pJS.canvas.ctx.stroke();
	        pJS.canvas.ctx.closePath();
	
	      }
	
	    }
	
	  };
	
	
	  pJS.fn.interact.attractParticles  = function(p1, p2){
	
	    /* condensed particles */
	    var dx = p1.x - p2.x,
	        dy = p1.y - p2.y,
	        dist = Math.sqrt(dx*dx + dy*dy);
	
	    if(dist <= pJS.particles.line_linked.distance){
	
	      var ax = dx/(pJS.particles.move.attract.rotateX*1000),
	          ay = dy/(pJS.particles.move.attract.rotateY*1000);
	
	      p1.vx -= ax;
	      p1.vy -= ay;
	
	      p2.vx += ax;
	      p2.vy += ay;
	
	    }
	    
	
	  }
	
	
	  pJS.fn.interact.bounceParticles = function(p1, p2){
	
	    var dx = p1.x - p2.x,
	        dy = p1.y - p2.y,
	        dist = Math.sqrt(dx*dx + dy*dy),
	        dist_p = p1.radius+p2.radius;
	
	    if(dist <= dist_p){
	      p1.vx = -p1.vx;
	      p1.vy = -p1.vy;
	
	      p2.vx = -p2.vx;
	      p2.vy = -p2.vy;
	    }
	
	  }
	
	
	  /* ---------- pJS functions - modes events ------------ */
	
	  pJS.fn.modes.pushParticles = function(nb, pos){
	
	    pJS.tmp.pushing = true;
	
	    for(var i = 0; i < nb; i++){
	      pJS.particles.array.push(
	        new pJS.fn.particle(
	          pJS.particles.color,
	          pJS.particles.opacity.value,
	          {
	            'x': pos ? pos.pos_x : Math.random() * pJS.canvas.w,
	            'y': pos ? pos.pos_y : Math.random() * pJS.canvas.h
	          }
	        )
	      )
	      if(i == nb-1){
	        if(!pJS.particles.move.enable){
	          pJS.fn.particlesDraw();
	        }
	        pJS.tmp.pushing = false;
	      }
	    }
	
	  };
	
	
	  pJS.fn.modes.removeParticles = function(nb){
	
	    pJS.particles.array.splice(0, nb);
	    if(!pJS.particles.move.enable){
	      pJS.fn.particlesDraw();
	    }
	
	  };
	
	
	  pJS.fn.modes.bubbleParticle = function(p){
	
	    /* on hover event */
	    if(pJS.interactivity.events.onhover.enable && isInArray('bubble', pJS.interactivity.events.onhover.mode)){
	
	      var dx_mouse = p.x - pJS.interactivity.mouse.pos_x,
	          dy_mouse = p.y - pJS.interactivity.mouse.pos_y,
	          dist_mouse = Math.sqrt(dx_mouse*dx_mouse + dy_mouse*dy_mouse),
	          ratio = 1 - dist_mouse / pJS.interactivity.modes.bubble.distance;
	
	      function init(){
	        p.opacity_bubble = p.opacity;
	        p.radius_bubble = p.radius;
	      }
	
	      /* mousemove - check ratio */
	      if(dist_mouse <= pJS.interactivity.modes.bubble.distance){
	
	        if(ratio >= 0 && pJS.interactivity.status == 'mousemove'){
	          
	          /* size */
	          if(pJS.interactivity.modes.bubble.size != pJS.particles.size.value){
	
	            if(pJS.interactivity.modes.bubble.size > pJS.particles.size.value){
	              var size = p.radius + (pJS.interactivity.modes.bubble.size*ratio);
	              if(size >= 0){
	                p.radius_bubble = size;
	              }
	            }else{
	              var dif = p.radius - pJS.interactivity.modes.bubble.size,
	                  size = p.radius - (dif*ratio);
	              if(size > 0){
	                p.radius_bubble = size;
	              }else{
	                p.radius_bubble = 0;
	              }
	            }
	
	          }
	
	          /* opacity */
	          if(pJS.interactivity.modes.bubble.opacity != pJS.particles.opacity.value){
	
	            if(pJS.interactivity.modes.bubble.opacity > pJS.particles.opacity.value){
	              var opacity = pJS.interactivity.modes.bubble.opacity*ratio;
	              if(opacity > p.opacity && opacity <= pJS.interactivity.modes.bubble.opacity){
	                p.opacity_bubble = opacity;
	              }
	            }else{
	              var opacity = p.opacity - (pJS.particles.opacity.value-pJS.interactivity.modes.bubble.opacity)*ratio;
	              if(opacity < p.opacity && opacity >= pJS.interactivity.modes.bubble.opacity){
	                p.opacity_bubble = opacity;
	              }
	            }
	
	          }
	
	        }
	
	      }else{
	        init();
	      }
	
	
	      /* mouseleave */
	      if(pJS.interactivity.status == 'mouseleave'){
	        init();
	      }
	    
	    }
	
	    /* on click event */
	    else if(pJS.interactivity.events.onclick.enable && isInArray('bubble', pJS.interactivity.events.onclick.mode)){
	
	
	      if(pJS.tmp.bubble_clicking){
	        var dx_mouse = p.x - pJS.interactivity.mouse.click_pos_x,
	            dy_mouse = p.y - pJS.interactivity.mouse.click_pos_y,
	            dist_mouse = Math.sqrt(dx_mouse*dx_mouse + dy_mouse*dy_mouse),
	            time_spent = (new Date().getTime() - pJS.interactivity.mouse.click_time)/1000;
	
	        if(time_spent > pJS.interactivity.modes.bubble.duration){
	          pJS.tmp.bubble_duration_end = true;
	        }
	
	        if(time_spent > pJS.interactivity.modes.bubble.duration*2){
	          pJS.tmp.bubble_clicking = false;
	          pJS.tmp.bubble_duration_end = false;
	        }
	      }
	
	
	      function process(bubble_param, particles_param, p_obj_bubble, p_obj, id){
	
	        if(bubble_param != particles_param){
	
	          if(!pJS.tmp.bubble_duration_end){
	            if(dist_mouse <= pJS.interactivity.modes.bubble.distance){
	              if(p_obj_bubble != undefined) var obj = p_obj_bubble;
	              else var obj = p_obj;
	              if(obj != bubble_param){
	                var value = p_obj - (time_spent * (p_obj - bubble_param) / pJS.interactivity.modes.bubble.duration);
	                if(id == 'size') p.radius_bubble = value;
	                if(id == 'opacity') p.opacity_bubble = value;
	              }
	            }else{
	              if(id == 'size') p.radius_bubble = undefined;
	              if(id == 'opacity') p.opacity_bubble = undefined;
	            }
	          }else{
	            if(p_obj_bubble != undefined){
	              var value_tmp = p_obj - (time_spent * (p_obj - bubble_param) / pJS.interactivity.modes.bubble.duration),
	                  dif = bubble_param - value_tmp;
	                  value = bubble_param + dif;
	              if(id == 'size') p.radius_bubble = value;
	              if(id == 'opacity') p.opacity_bubble = value;
	            }
	          }
	
	        }
	
	      }
	
	      if(pJS.tmp.bubble_clicking){
	        /* size */
	        process(pJS.interactivity.modes.bubble.size, pJS.particles.size.value, p.radius_bubble, p.radius, 'size');
	        /* opacity */
	        process(pJS.interactivity.modes.bubble.opacity, pJS.particles.opacity.value, p.opacity_bubble, p.opacity, 'opacity');
	      }
	
	    }
	
	  };
	
	
	  pJS.fn.modes.repulseParticle = function(p){
	
	    if(pJS.interactivity.events.onhover.enable && isInArray('repulse', pJS.interactivity.events.onhover.mode) && pJS.interactivity.status == 'mousemove') {
	
	      var dx_mouse = p.x - pJS.interactivity.mouse.pos_x,
	          dy_mouse = p.y - pJS.interactivity.mouse.pos_y,
	          dist_mouse = Math.sqrt(dx_mouse*dx_mouse + dy_mouse*dy_mouse);
	
	      var normVec = {x: dx_mouse/dist_mouse, y: dy_mouse/dist_mouse},
	          repulseRadius = pJS.interactivity.modes.repulse.distance,
	          velocity = 100,
	          repulseFactor = clamp((1/repulseRadius)*(-1*Math.pow(dist_mouse/repulseRadius,2)+1)*repulseRadius*velocity, 0, 50);
	      
	      var pos = {
	        x: p.x + normVec.x * repulseFactor,
	        y: p.y + normVec.y * repulseFactor
	      }
	
	      if(pJS.particles.move.out_mode == 'bounce'){
	        if(pos.x - p.radius > 0 && pos.x + p.radius < pJS.canvas.w) p.x = pos.x;
	        if(pos.y - p.radius > 0 && pos.y + p.radius < pJS.canvas.h) p.y = pos.y;
	      }else{
	        p.x = pos.x;
	        p.y = pos.y;
	      }
	    
	    }
	
	
	    else if(pJS.interactivity.events.onclick.enable && isInArray('repulse', pJS.interactivity.events.onclick.mode)) {
	
	      if(!pJS.tmp.repulse_finish){
	        pJS.tmp.repulse_count++;
	        if(pJS.tmp.repulse_count == pJS.particles.array.length){
	          pJS.tmp.repulse_finish = true;
	        }
	      }
	
	      if(pJS.tmp.repulse_clicking){
	
	        var repulseRadius = Math.pow(pJS.interactivity.modes.repulse.distance/6, 3);
	
	        var dx = pJS.interactivity.mouse.click_pos_x - p.x,
	            dy = pJS.interactivity.mouse.click_pos_y - p.y,
	            d = dx*dx + dy*dy;
	
	        var force = -repulseRadius / d * 1;
	
	        function process(){
	
	          var f = Math.atan2(dy,dx);
	          p.vx = force * Math.cos(f);
	          p.vy = force * Math.sin(f);
	
	          if(pJS.particles.move.out_mode == 'bounce'){
	            var pos = {
	              x: p.x + p.vx,
	              y: p.y + p.vy
	            }
	            if (pos.x + p.radius > pJS.canvas.w) p.vx = -p.vx;
	            else if (pos.x - p.radius < 0) p.vx = -p.vx;
	            if (pos.y + p.radius > pJS.canvas.h) p.vy = -p.vy;
	            else if (pos.y - p.radius < 0) p.vy = -p.vy;
	          }
	
	        }
	
	        // default
	        if(d <= repulseRadius){
	          process();
	        }
	
	        // bang - slow motion mode
	        // if(!pJS.tmp.repulse_finish){
	        //   if(d <= repulseRadius){
	        //     process();
	        //   }
	        // }else{
	        //   process();
	        // }
	        
	
	      }else{
	
	        if(pJS.tmp.repulse_clicking == false){
	
	          p.vx = p.vx_i;
	          p.vy = p.vy_i;
	        
	        }
	
	      }
	
	    }
	
	  }
	
	
	  pJS.fn.modes.grabParticle = function(p){
	
	    if(pJS.interactivity.events.onhover.enable && pJS.interactivity.status == 'mousemove'){
	
	      var dx_mouse = p.x - pJS.interactivity.mouse.pos_x,
	          dy_mouse = p.y - pJS.interactivity.mouse.pos_y,
	          dist_mouse = Math.sqrt(dx_mouse*dx_mouse + dy_mouse*dy_mouse);
	
	      /* draw a line between the cursor and the particle if the distance between them is under the config distance */
	      if(dist_mouse <= pJS.interactivity.modes.grab.distance){
	
	        var opacity_line = pJS.interactivity.modes.grab.line_linked.opacity - (dist_mouse / (1/pJS.interactivity.modes.grab.line_linked.opacity)) / pJS.interactivity.modes.grab.distance;
	
	        if(opacity_line > 0){
	
	          /* style */
	          var color_line = pJS.particles.line_linked.color_rgb_line;
	          pJS.canvas.ctx.strokeStyle = 'rgba('+color_line.r+','+color_line.g+','+color_line.b+','+opacity_line+')';
	          pJS.canvas.ctx.lineWidth = pJS.particles.line_linked.width;
	          //pJS.canvas.ctx.lineCap = 'round'; /* performance issue */
	          
	          /* path */
	          pJS.canvas.ctx.beginPath();
	          pJS.canvas.ctx.moveTo(p.x, p.y);
	          pJS.canvas.ctx.lineTo(pJS.interactivity.mouse.pos_x, pJS.interactivity.mouse.pos_y);
	          pJS.canvas.ctx.stroke();
	          pJS.canvas.ctx.closePath();
	
	        }
	
	      }
	
	    }
	
	  };
	
	
	
	  /* ---------- pJS functions - vendors ------------ */
	
	  pJS.fn.vendors.eventsListeners = function(){
	
	    /* events target element */
	    if(pJS.interactivity.detect_on == 'window'){
	      pJS.interactivity.el = window;
	    }else{
	      pJS.interactivity.el = pJS.canvas.el;
	    }
	
	
	    /* detect mouse pos - on hover / click event */
	    if(pJS.interactivity.events.onhover.enable || pJS.interactivity.events.onclick.enable){
	
	      /* el on mousemove */
	      pJS.interactivity.el.addEventListener('mousemove', function(e){
	
	        if(pJS.interactivity.el == window){
	          var pos_x = e.clientX,
	              pos_y = e.clientY;
	        }
	        else{
	          var pos_x = e.offsetX || e.clientX,
	              pos_y = e.offsetY || e.clientY;
	        }
	
	        pJS.interactivity.mouse.pos_x = pos_x;
	        pJS.interactivity.mouse.pos_y = pos_y;
	
	        if(pJS.tmp.retina){
	          pJS.interactivity.mouse.pos_x *= pJS.canvas.pxratio;
	          pJS.interactivity.mouse.pos_y *= pJS.canvas.pxratio;
	        }
	
	        pJS.interactivity.status = 'mousemove';
	
	      });
	
	      /* el on onmouseleave */
	      pJS.interactivity.el.addEventListener('mouseleave', function(e){
	
	        pJS.interactivity.mouse.pos_x = null;
	        pJS.interactivity.mouse.pos_y = null;
	        pJS.interactivity.status = 'mouseleave';
	
	      });
	
	    }
	
	    /* on click event */
	    if(pJS.interactivity.events.onclick.enable){
	
	      pJS.interactivity.el.addEventListener('click', function(){
	
	        pJS.interactivity.mouse.click_pos_x = pJS.interactivity.mouse.pos_x;
	        pJS.interactivity.mouse.click_pos_y = pJS.interactivity.mouse.pos_y;
	        pJS.interactivity.mouse.click_time = new Date().getTime();
	
	        if(pJS.interactivity.events.onclick.enable){
	
	          switch(pJS.interactivity.events.onclick.mode){
	
	            case 'push':
	              if(pJS.particles.move.enable){
	                pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb, pJS.interactivity.mouse);
	              }else{
	                if(pJS.interactivity.modes.push.particles_nb == 1){
	                  pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb, pJS.interactivity.mouse);
	                }
	                else if(pJS.interactivity.modes.push.particles_nb > 1){
	                  pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb);
	                }
	              }
	            break;
	
	            case 'remove':
	              pJS.fn.modes.removeParticles(pJS.interactivity.modes.remove.particles_nb);
	            break;
	
	            case 'bubble':
	              pJS.tmp.bubble_clicking = true;
	            break;
	
	            case 'repulse':
	              pJS.tmp.repulse_clicking = true;
	              pJS.tmp.repulse_count = 0;
	              pJS.tmp.repulse_finish = false;
	              setTimeout(function(){
	                pJS.tmp.repulse_clicking = false;
	              }, pJS.interactivity.modes.repulse.duration*1000)
	            break;
	
	          }
	
	        }
	
	      });
	        
	    }
	
	
	  };
	
	  pJS.fn.vendors.densityAutoParticles = function(){
	
	    if(pJS.particles.number.density.enable){
	
	      /* calc area */
	      var area = pJS.canvas.el.width * pJS.canvas.el.height / 1000;
	      if(pJS.tmp.retina){
	        area = area/(pJS.canvas.pxratio*2);
	      }
	
	      /* calc number of particles based on density area */
	      var nb_particles = area * pJS.particles.number.value / pJS.particles.number.density.value_area;
	
	      /* add or remove X particles */
	      var missing_particles = pJS.particles.array.length - nb_particles;
	      if(missing_particles < 0) pJS.fn.modes.pushParticles(Math.abs(missing_particles));
	      else pJS.fn.modes.removeParticles(missing_particles);
	
	    }
	
	  };
	
	
	  pJS.fn.vendors.checkOverlap = function(p1, position){
	    for(var i = 0; i < pJS.particles.array.length; i++){
	      var p2 = pJS.particles.array[i];
	
	      var dx = p1.x - p2.x,
	          dy = p1.y - p2.y,
	          dist = Math.sqrt(dx*dx + dy*dy);
	
	      if(dist <= p1.radius + p2.radius){
	        p1.x = position ? position.x : Math.random() * pJS.canvas.w;
	        p1.y = position ? position.y : Math.random() * pJS.canvas.h;
	        pJS.fn.vendors.checkOverlap(p1);
	      }
	    }
	  };
	
	
	  pJS.fn.vendors.createSvgImg = function(p){
	
	    /* set color to svg element */
	    var svgXml = pJS.tmp.source_svg,
	        rgbHex = /#([0-9A-F]{3,6})/gi,
	        coloredSvgXml = svgXml.replace(rgbHex, function (m, r, g, b) {
	          if(p.color.rgb){
	            var color_value = 'rgba('+p.color.rgb.r+','+p.color.rgb.g+','+p.color.rgb.b+','+p.opacity+')';
	          }else{
	            var color_value = 'hsla('+p.color.hsl.h+','+p.color.hsl.s+'%,'+p.color.hsl.l+'%,'+p.opacity+')';
	          }
	          return color_value;
	        });
	
	    /* prepare to create img with colored svg */
	    var svg = new Blob([coloredSvgXml], {type: 'image/svg+xml;charset=utf-8'}),
	        DOMURL = window.URL || window.webkitURL || window,
	        url = DOMURL.createObjectURL(svg);
	
	    /* create particle img obj */
	    var img = new Image();
	    img.addEventListener('load', function(){
	      p.img.obj = img;
	      p.img.loaded = true;
	      DOMURL.revokeObjectURL(url);
	      pJS.tmp.count_svg++;
	    });
	    img.src = url;
	
	  };
	
	
	  pJS.fn.vendors.destroypJS = function(){
	    cancelAnimationFrame(pJS.fn.drawAnimFrame);
	    canvas_el.remove();
	    pJSDom = null;
	  };
	
	
	  pJS.fn.vendors.drawShape = function(c, startX, startY, sideLength, sideCountNumerator, sideCountDenominator){
	
	    // By Programming Thomas - https://programmingthomas.wordpress.com/2013/04/03/n-sided-shapes/
	    var sideCount = sideCountNumerator * sideCountDenominator;
	    var decimalSides = sideCountNumerator / sideCountDenominator;
	    var interiorAngleDegrees = (180 * (decimalSides - 2)) / decimalSides;
	    var interiorAngle = Math.PI - Math.PI * interiorAngleDegrees / 180; // convert to radians
	    c.save();
	    c.beginPath();
	    c.translate(startX, startY);
	    c.moveTo(0,0);
	    for (var i = 0; i < sideCount; i++) {
	      c.lineTo(sideLength,0);
	      c.translate(sideLength,0);
	      c.rotate(interiorAngle);
	    }
	    //c.stroke();
	    c.fill();
	    c.restore();
	
	  };
	
	  pJS.fn.vendors.exportImg = function(){
	    window.open(pJS.canvas.el.toDataURL('image/png'), '_blank');
	  };
	
	
	  pJS.fn.vendors.loadImg = function(type){
	
	    pJS.tmp.img_error = undefined;
	
	    if(pJS.particles.shape.image.src != ''){
	
	      if(type == 'svg'){
	
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', pJS.particles.shape.image.src);
	        xhr.onreadystatechange = function (data) {
	          if(xhr.readyState == 4){
	            if(xhr.status == 200){
	              pJS.tmp.source_svg = data.currentTarget.response;
	              pJS.fn.vendors.checkBeforeDraw();
	            }else{
	              console.log('Error pJS - Image not found');
	              pJS.tmp.img_error = true;
	            }
	          }
	        }
	        xhr.send();
	
	      }else{
	
	        var img = new Image();
	        img.addEventListener('load', function(){
	          pJS.tmp.img_obj = img;
	          pJS.fn.vendors.checkBeforeDraw();
	        });
	        img.src = pJS.particles.shape.image.src;
	
	      }
	
	    }else{
	      console.log('Error pJS - No image.src');
	      pJS.tmp.img_error = true;
	    }
	
	  };
	
	
	  pJS.fn.vendors.draw = function(){
	
	    if(pJS.particles.shape.type == 'image'){
	
	      if(pJS.tmp.img_type == 'svg'){
	
	        if(pJS.tmp.count_svg >= pJS.particles.number.value){
	          pJS.fn.particlesDraw();
	          if(!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
	          else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
	        }else{
	          //console.log('still loading...');
	          if(!pJS.tmp.img_error) pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
	        }
	
	      }else{
	
	        if(pJS.tmp.img_obj != undefined){
	          pJS.fn.particlesDraw();
	          if(!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
	          else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
	        }else{
	          if(!pJS.tmp.img_error) pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
	        }
	
	      }
	
	    }else{
	      pJS.fn.particlesDraw();
	      if(!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
	      else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
	    }
	
	  };
	
	
	  pJS.fn.vendors.checkBeforeDraw = function(){
	
	    // if shape is image
	    if(pJS.particles.shape.type == 'image'){
	
	      if(pJS.tmp.img_type == 'svg' && pJS.tmp.source_svg == undefined){
	        pJS.tmp.checkAnimFrame = requestAnimFrame(check);
	      }else{
	        //console.log('images loaded! cancel check');
	        cancelRequestAnimFrame(pJS.tmp.checkAnimFrame);
	        if(!pJS.tmp.img_error){
	          pJS.fn.vendors.init();
	          pJS.fn.vendors.draw();
	        }
	        
	      }
	
	    }else{
	      pJS.fn.vendors.init();
	      pJS.fn.vendors.draw();
	    }
	
	  };
	
	
	  pJS.fn.vendors.init = function(){
	
	    /* init canvas + particles */
	    pJS.fn.retinaInit();
	    pJS.fn.canvasInit();
	    pJS.fn.canvasSize();
	    pJS.fn.canvasPaint();
	    pJS.fn.particlesCreate();
	    pJS.fn.vendors.densityAutoParticles();
	
	    /* particles.line_linked - convert hex colors to rgb */
	    pJS.particles.line_linked.color_rgb_line = hexToRgb(pJS.particles.line_linked.color);
	
	  };
	
	
	  pJS.fn.vendors.start = function(){
	
	    if(isInArray('image', pJS.particles.shape.type)){
	      pJS.tmp.img_type = pJS.particles.shape.image.src.substr(pJS.particles.shape.image.src.length - 3);
	      pJS.fn.vendors.loadImg(pJS.tmp.img_type);
	    }else{
	      pJS.fn.vendors.checkBeforeDraw();
	    }
	
	  };
	
	
	
	
	  /* ---------- pJS - start ------------ */
	
	
	  pJS.fn.vendors.eventsListeners();
	
	  pJS.fn.vendors.start();
	  
	
	
	};
	
	/* ---------- global functions - vendors ------------ */
	
	Object.deepExtend = function(destination, source) {
	  for (var property in source) {
	    if (source[property] && source[property].constructor &&
	     source[property].constructor === Object) {
	      destination[property] = destination[property] || {};
	      arguments.callee(destination[property], source[property]);
	    } else {
	      destination[property] = source[property];
	    }
	  }
	  return destination;
	};
	
	window.requestAnimFrame = (function(){
	  return  window.requestAnimationFrame ||
	    window.webkitRequestAnimationFrame ||
	    window.mozRequestAnimationFrame    ||
	    window.oRequestAnimationFrame      ||
	    window.msRequestAnimationFrame     ||
	    function(callback){
	      window.setTimeout(callback, 1000 / 60);
	    };
	})();
	
	window.cancelRequestAnimFrame = ( function() {
	  return window.cancelAnimationFrame         ||
	    window.webkitCancelRequestAnimationFrame ||
	    window.mozCancelRequestAnimationFrame    ||
	    window.oCancelRequestAnimationFrame      ||
	    window.msCancelRequestAnimationFrame     ||
	    clearTimeout
	} )();
	
	function hexToRgb(hex){
	  // By Tim Down - http://stackoverflow.com/a/5624139/3493650
	  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
	     return r + r + g + g + b + b;
	  });
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	  } : null;
	};
	
	function clamp(number, min, max) {
	  return Math.min(Math.max(number, min), max);
	};
	
	function isInArray(value, array) {
	  return array.indexOf(value) > -1;
	}
	
	
	/* ---------- particles.js functions - start ------------ */
	
	window.pJSDom = [];
	
	window.particlesJS = function(tag_id, params){
	
	  //console.log(params);
	
	  /* no string id? so it's object params, and set the id with default id */
	  if(typeof(tag_id) != 'string'){
	    params = tag_id;
	    tag_id = 'particles-js';
	  }
	
	  /* no id? set the id to default id */
	  if(!tag_id){
	    tag_id = 'particles-js';
	  }
	
	  /* pJS elements */
	  var pJS_tag = document.getElementById(tag_id),
	      pJS_canvas_class = 'particles-js-canvas-el',
	      exist_canvas = pJS_tag.getElementsByClassName(pJS_canvas_class);
	
	  /* remove canvas if exists into the pJS target tag */
	  if(exist_canvas.length){
	    while(exist_canvas.length > 0){
	      pJS_tag.removeChild(exist_canvas[0]);
	    }
	  }
	
	  /* create canvas element */
	  var canvas_el = document.createElement('canvas');
	  canvas_el.className = pJS_canvas_class;
	
	  /* set size canvas */
	  canvas_el.style.width = "100%";
	  canvas_el.style.height = "100%";
	
	  /* append canvas */
	  var canvas = document.getElementById(tag_id).appendChild(canvas_el);
	
	  /* launch particle.js */
	  if(canvas != null){
	    pJSDom.push(new pJS(tag_id, params));
	  }
	
	};
	
	window.particlesJS.load = function(tag_id, path_config_json, callback){
	
	  /* load json config */
	  var xhr = new XMLHttpRequest();
	  xhr.open('GET', path_config_json);
	  xhr.onreadystatechange = function (data) {
	    if(xhr.readyState == 4){
	      if(xhr.status == 200){
	        var params = JSON.parse(data.currentTarget.response);
	        window.particlesJS(tag_id, params);
	        if(callback) callback();
	      }else{
	        console.log('Error pJS - XMLHttpRequest status: '+xhr.status);
	        console.log('Error pJS - File config not found');
	      }
	    }
	  };
	  xhr.send();
	
	};

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(412);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(392);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(394);
	
	var _HelmetConstants = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(261);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(427);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var lang = '_nl';
	
	exports.lang = lang;

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(86);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(393);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(320);
	
	__webpack_require__(321);
	
	__webpack_require__(323);
	
	__webpack_require__(322);
	
	var _logo = __webpack_require__(429);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _utilities = __webpack_require__(184);
	
	var _language = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof window !== 'undefined') {
	  __webpack_require__(325);
	}
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var version = this.props.version;
	
	    return _react2.default.createElement(
	      'header',
	      { className: 's-header' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _react2.default.createElement('img', { className: 'logo', src: _logo2.default })
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: 'theme-name' },
	        'Ocelli Ocellus - ',
	        version.version
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'hamburger', onClick: this.toggleNav },
	        _react2.default.createElement(
	          'i',
	          { className: 'material-icons' },
	          'menu'
	        )
	      )
	    );
	  };
	
	  Header.prototype.toggleNav = function toggleNav() {
	    document.querySelector('.s-sidebar').classList.toggle('state-active');
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	var Navigation = function (_React$Component2) {
	  _inherits(Navigation, _React$Component2);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var navItems = this.props.navItems;
	    var homepage = this.props.homepage;
	    var pathname = typeof window !== 'undefined' ? window.location.pathname : false;
	
	    return _react2.default.createElement(
	      'nav',
	      { className: 's-sidebar' },
	      _react2.default.createElement('div', { className: 'particles-background', id: 'js-particles-background' }),
	      _react2.default.createElement(
	        'ul',
	        { className: 'navigation' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: (0, _utilities.classNames)('navigation-link', { 'state-active': ("/guides/ocelli-ocellus/nl") + '/' == pathname }), to: '/' },
	            homepage['heading' + _language.lang]
	          )
	        ),
	        navItems.map(function (_ref, index) {
	          var node = _ref.node;
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: (0, _utilities.classNames)('navigation-link', { 'state-active': ("/guides/ocelli-ocellus/nl") + '/' + node.url == pathname }), to: '/' + node.url },
	              node['title' + _language.lang]
	            )
	          );
	        })
	      )
	    );
	  };
	
	  Navigation.prototype.componentDidMount = function componentDidMount() {
	    particlesJS.load('js-particles-background', ("/guides/ocelli-ocellus/nl") + '/particles.config.json');
	  };
	
	  return Navigation;
	}(_react2.default.Component);
	
	var TemplateWrapper = function TemplateWrapper(_ref2) {
	  var children = _ref2.children,
	      data = _ref2.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Guide: Theme Ocelli Ocellus'
	      ),
	      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900' }),
	      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' }),
	      _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	    ),
	    _react2.default.createElement(Header, { version: data.allTranslationsXlsxChangelog.edges[0].node }),
	    _react2.default.createElement(
	      'main',
	      { className: 's-main' },
	      _react2.default.createElement(Navigation, {
	        homepage: data.allTranslationsXlsxHomepage.edges[0].node,
	        navItems: data.allTranslationsXlsxSections.edges
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'content' },
	        children()
	      )
	    )
	  );
	};
	
	exports.default = TemplateWrapper;
	
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNames = classNames;
	function classNames() {
	  var classNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var conditionalClassNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (classNames + ' ').concat(Object.keys(conditionalClassNames).filter(function (key) {
	    return conditionalClassNames[key];
	  }).join(' '));
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7d795cbe2c06a35848eb.js